import script from "./NotesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotesModal.vue?vue&type=script&setup=true&lang=ts"

import "./NotesModal.vue?vue&type=style&index=0&id=47f81bba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f81bba"]])

export default __exports__